import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Avatar,
  Box,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import ProtectedImage from "../../../components/ProtectedImage";
import EmployeeProfileVeiwController from "../../../redux/actions/EmployeeProfileApiAction";


const ProfileImageUpload = ({ open, onClose, currentImage, userId }) => {
  const dispatch = useDispatch();
  const { updateEmployee } = EmployeeProfileVeiwController();
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currentImage) {
      setPreview(currentImage);
    }
  }, [currentImage]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
      setImageFile(reader.result); // base64 string
    };
    reader.readAsDataURL(file);
  };

  const handleSave = () => {
    if (!imageFile) return;
    setLoading(true);
    const payload = {
      id: userId,
      profile: {
        profile_image: imageFile,
      },
    };
    dispatch(updateEmployee(userId, payload));
    setLoading(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Update Profile Image
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Avatar
            sx={{ width: 120, height: 120, border: "2px solid #004466" }}
          >
            {preview ? (
              <ProtectedImage
                path={preview}
                alt="Profile Image"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            ) : (
              "N/A"
            )}
          </Avatar>
          <input type="file" accept="image/*" onChange={handleFileChange} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!imageFile || loading}
        >
          {loading ? <CircularProgress size={20} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProfileImageUpload;
